import { useQuery } from "@tanstack/react-query";
import useWidgetStore from "../../store/useWidgetStore";
import ConfigHolder from "../../config/ConfigHolder";
import { prepareUrl } from "../../context/WidgetContext";
import { useSettings } from "../../context/SettingsContext";
import dayjs from 'dayjs';
export const useDates = (options) => {
    const { enabled, selectedApptype, selectedResource, selectedDate, selectedGroup, selectedCapacity, selectedCapacityGroups } = useWidgetStore();
    const { api_key, widget_id } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: enabled.date && selectedCapacity > 0 && selectedResource && selectedResource[0] !== undefined, networkMode: "online", cacheTime: 60 * 1000 * 2, staleTime: 60 * 1000 * 2 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-date', selectedApptype, selectedResource, selectedDate, selectedCapacity, selectedCapacityGroups], queryFn: async ({ signal }) => {
            let url = new URL(`/consumer/booking/api/method/getDates`, ConfigHolder.apiBaseUrl);
            let month = selectedDate && selectedDate[0] !== undefined
                ? dayjs(selectedDate[0]).format('YYYYMM')
                : dayjs().format('YYYYMM');
            let capacities = JSON.stringify(selectedCapacityGroups);
            if (selectedCapacityGroups[0]) {
                // if group 0 is "set", make sure it represent the overall capacity
                capacities = JSON.stringify({ 0: selectedCapacity });
            }
            url = prepareUrl(url, 'getDates', api_key, widget_id, {
                filter_apptype: '',
                filter_resource: '',
                apptypes: selectedApptype && selectedApptype[0] !== undefined ? selectedApptype === null || selectedApptype === void 0 ? void 0 : selectedApptype.join(',') : -1,
                resource: selectedResource && selectedResource[0] !== undefined ? selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.join(',') : "",
                category: selectedGroup && selectedGroup[0] !== undefined ? selectedGroup.join(',') : -1,
                capacity: selectedCapacity,
                capacities: capacities,
                month: month,
                first: 1
            });
            const response = await fetch(url.href, {
                signal: signal,
                headers: {
                    'accept': 'application/ld+json',
                }
            });
            return response.json();
        } }));
};
